import React from 'react'
import PropTypes from 'prop-types'
import NumberInput from './NumberInput'
import { isValidPhoneNumber, removeCountryCode } from 'helpers/formatters'
import { validateInput } from 'src/helpers/input'

const propTypes = {
  className: PropTypes.string,
  conditions: PropTypes.arrayOf(PropTypes.object),
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  parse: PropTypes.func,
  value: PropTypes.string
}

const defaultProps = {
  defaultValue: ''
}

const PhoneInput = ({
  conditions,
  defaultValue,
  onChange,
  parse,
  value,
  ...restProps
}) => {
  // Phone Num from the backend contains the international code (+1)
  // Must remove international code to successfully display
  const domesticPhoneNumber = value
    ? removeCountryCode(value)
    : removeCountryCode(defaultValue)

  return (
    <NumberInput
      value={domesticPhoneNumber}
      data-qa='phoneNumberField'
      format='###-###-####'
      mask='_'
      onChange={e => {
        const [, value] = validateInput(e.target, conditions, parse)
        if (onChange) onChange(e, value)
      }}
      {...restProps}
    />
  )
}

PropTypes.defaultProps = defaultProps
PhoneInput.propTypes = propTypes
PhoneInput.validNumber = () => ({
  message: 'Value must be 10 digits',
  validate: value => isValidPhoneNumber(value)
})

export default PhoneInput
